export default "/images/cartoo-password-success.svg?d51c67f236370b5ba48ac6b9f3540d02";